import * as React from "react";

const SectionHeader = ({ title, description }: { title: string; description: string; }) => {
    return (
        <div className="text-center">
            <p className="mt-2 text-5xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
                {title}
            </p>
            <p className="mx-auto mt-6 max-w-2xl text-md sm:text-lg leading-8 text-gray-400">
                {description}
            </p>
        </div >
    );
};

export default SectionHeader;
